import ajax from './ajax';
import {getStorageUserRoleId} from '@/utils/store'
export default new ajax({
  timeout: 300000, // 请求超时时间
  headers: {
    'Content-Type': 'application/json;charset=utf-8',
    "ManageUserId":getStorageUserRoleId()
  }
}, config => {
  // 你可以在这里做一些请求你前的操作
  return config
}, response => {
  // 你可以在这里做一些返回数据操作
  return response.data
})

